export default ({ field: { place, value, $changed } }) => {
  if (!$changed) return true;
  if (!place) return 'Please select the location from the drop down';
  if (value !== place.formatted_address) {
    return 'Please click the selection in drop down that matches the address';
  }

  return true;
};
